/*
 * Copyright (c) Airbus SAS. All rights reserved.
 */

/**
 * Initialise an EasyMDE editor on each `[data-markdown-editor]` element.
 * EasyMDE and its CSS are loaded lazily on first use, and the editor is
 * torn down via `toTextArea()` on cleanup.
 *
 * @type {Listener}
 */
export default {
    selector: '[data-markdown-editor]',
    async connect(element) {
        const [{ default: EasyMDE }] = await Promise.all([
            import('easymde'),
            import('easymde/dist/easymde.min.css'),
            import('font-awesome/css/font-awesome.min.css'),
        ])

        // The dataset flag guards against a second initialiser outside the
        // App lifecycle (admin.js connects this listener manually).
        if (element.dataset.markdownEditorInitialized) {
            return
        }

        const editor = new EasyMDE({
            element,
            spellChecker: false,
            status: false,
            autoDownloadFontAwesome: false,
            toolbar: [
                'bold',
                'italic',
                'strikethrough',
                '|',
                'heading-1',
                'heading-2',
                'heading-3',
                '|',
                'unordered-list',
                'ordered-list',
                '|',
                'link',
                '|',
                'preview',
                'side-by-side',
                'fullscreen',
                '|',
                'guide',
            ],
            minHeight: element.dataset.markdownEditorHeight || '200px',
            placeholder: element.placeholder || 'Enter markdown content...',
        })
        element.dataset.markdownEditorInitialized = 'true'

        return () => {
            editor.toTextArea()
            delete element.dataset.markdownEditorInitialized
        }
    },
}
